import type { FaireProductEntity } from "../../entity_types/product";

export const p_nr6tupj8tr: FaireProductEntity = {
  token: "p_nr6tupj8tr",
  type: "product",
  name: "Kids Patriotic Graphic Tee | Boys 4th of July + Summer Shirt",
  brandToken: "b_xp76rbjked",
  brandName: "Holland Ave Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/3c69a0d5ebf6136cf368576d7151bd095d88e9b3194c37098ce9c524889f215d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c57a7c4ccfa5af5be994dd28653aea67dce7e82b689e64cb98b6bd0d9c97612.png",
    "https://cdn.faire.com/fastly/8647206f12468879cdfbec8b8eff000a3b6c59a567a06a61996ef5eff7e9ab7d.png",
    "https://cdn.faire.com/fastly/b334088d54ebabd82321c3fd483d8ad27606bf9383fc6a1654b62869581ba960.png",
    "https://cdn.faire.com/fastly/6dc007d3787b1938a48cf01f6f9e68d69e716f01e8efba0a3e0b72b70497a68c.png",
  ],
  priceDollars: 12,
  description:
    "This trendy kids patriotic graphic tee features a bold skeleton hand design filled with classic red, white, and blue American flag elements. The edgy graphic gives this shirt a cool streetwear vibe that boys love while still being perfect for patriotic holidays.\n\nThis tee is a great addition to summer collections and sells especially well for Fourth of July celebrations, fireworks events, parades, and summer BBQs. The unique design stands out from traditional patriotic shirts, making it a fun option for boutiques looking for something a little different.\n\nParents love styling this tee with denim shorts, sneakers, and hats for a cool summer outfit.\n\nProduct Details\n• Soft premium cotton kids tee\n• Unisex toddler and youth fit\n• Professionally printed graphic\n• Durable print designed for everyday wear\n\nPerfect For Retail Displays\n• Fourth of July collections\n• Patriotic summer displays\n• Trendy boys graphic tees\n• Summer boutique outfits\n\nThis patriotic skeleton hand tee is a standout piece for boutiques looking to stock modern kids patriotic apparel for summer and Independence Day.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:33.361Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
